import React from "react";
import { IFormDropdownOption } from "src/components/Form/FormDropdown/FormDropdown";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import SingleSelectField from "src/components/Form/SingleSelectFieldV2/SingleSelectField";
import * as S from "src/constants/StringConstants";
import { openUrl } from "src/util/util.navigation";

interface AppBarInfoBoxProps {
  isNew: boolean;
  agentName: string;
  agentPhone: string;
  agentEmail: string;
  orgOptions: IFormDropdownOption[];
  caseManager: string;
  proposalID?: number;
  proposalSpecialist?: string;
  isReadonly?: boolean;
  hierarchyName?: string;
  userOptions: IFormDropdownOption[];
}

export const AppBarInfoBox = ({
  agentName,
  agentPhone,
  agentEmail,
  orgOptions,
  proposalID,
  proposalSpecialist,
  isReadonly,
  hierarchyName,
  userOptions,
}: AppBarInfoBoxProps) => {
  return (
    <div className="app-builder__info-table cols-4" {...{ inert: isReadonly ? "" : undefined }}>
      <div>
        <label>{S.APP_BUILDER_AGENT_NAME_LABEL}:</label>
        <span title={agentName}>{agentName || "-"}</span>
      </div>
      <div>
        <label>{S.APP_BUILDER_AGENT_PHONE_LABEL}:</label>
        <span>
          {agentPhone ? (
            <a title={agentPhone} href={`tel:${agentPhone}`}>
              {agentPhone}
            </a>
          ) : (
            "-"
          )}
        </span>
      </div>
      <div>
        <label>{S.APP_BUILDER_AGENT_EMAIL_LABEL}:</label>
        <span>
          {agentEmail ? (
            <a title={agentEmail} href={`mailto:${agentEmail}`}>
              {agentEmail}
            </a>
          ) : (
            "-"
          )}
        </span>
      </div>
      <div>
        <label>{S.APP_BUILDER_ORGANIZATION_LABEL}:</label>
        <SingleSelectField name="branchTypeID" options={orgOptions} bare />
      </div>
      <div>
        <label>{S.APP_BUILDER_HIERARCHY_LABEL}:</label>
        <span title={hierarchyName}>{hierarchyName || "-"}</span>
      </div>
      <div>
        <label>{S.APP_BUILDER_CASE_REVIEW_DATE_LABEL}:</label>
        <div className="applications-review-date">
          <SimpleDatePickerField name="reviewDate" bare />
        </div>
      </div>
      <div>
        <label>{S.APP_BUILDER_CASE_MANAGER_LABEL}:</label>
        <SingleSelectField name="uwSpecialistID" options={userOptions} bare />
      </div>
      {proposalID && (
        <>
          <div>
            <label>{S.APP_BUILDER_PROPOSAL_LABEL}:</label>
            <a
              onClick={e => {
                openUrl(`/proposals/${proposalID}/details`, true);
              }}>
              {proposalID}
            </a>
          </div>
          <div>
            <label>{S.APP_BUILDER_PROPOSAL_SPECIALIST_LABEL}:</label>
            <span>{proposalSpecialist}</span>
          </div>
        </>
      )}
    </div>
  );
};
